/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './ngx-gallery-thumbnails.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from './ngx-gallery-arrows.component.ngfactory';
import * as i4 from 'ngx-gallery/lib/ngx-gallery-arrows.component';
import * as i5 from 'ngx-gallery/lib/ngx-gallery-thumbnails.component';
import * as i6 from '@angular/platform-browser';
import * as i7 from 'ngx-gallery/lib/ngx-gallery-helper.service';
const styles_NgxGalleryThumbnailsComponent:any[] = [i0.styles];
export const RenderType_NgxGalleryThumbnailsComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_NgxGalleryThumbnailsComponent,data:{}});
function View_NgxGalleryThumbnailsComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'div',[['class',
      'ngx-gallery-thumbnail']],[[4,'background-image',(null as any)],[4,'width',(null as any)],
      [4,'height',(null as any)],[4,'left',(null as any)],[4,'top',(null as any)]],
      [[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.handleClick($event,_v.context.index)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(278528,(null as any),0,i2.NgClass,[i1.IterableDiffers,
      i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{klass:[0,'klass'],ngClass:[1,
      'ngClass']},(null as any)),i1.ɵpod({'ngx-gallery-active':0,'ngx-gallery-clickable':1})],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_5:any = 'ngx-gallery-thumbnail';
        const currVal_6:any = _ck(_v,2,0,(_v.context.index == _co.selectedIndex),_co.clickable);
        _ck(_v,1,0,currVal_5,currVal_6);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = (('url(' + _v.context.$implicit) + ')');
        const currVal_1:any = _co.getThumbnailWidth();
        const currVal_2:any = _co.getThumbnailHeight();
        const currVal_3:any = _co.getThumbnailLeft(_v.context.index);
        const currVal_4:any = _co.getThumbnailTop(_v.context.index);
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
      });
}
function View_NgxGalleryThumbnailsComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ngx-gallery-arrows',
      ([] as any[]),(null as any),[[(null as any),'onPrevClick'],[(null as any),'onNextClick']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('onPrevClick' === en)) {
          const pd_0:any = ((<any>_co.moveLeft()) !== false);
          ad = (pd_0 && ad);
        }
        if (('onNextClick' === en)) {
          const pd_1:any = ((<any>_co.moveRight()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i3.View_NgxGalleryArrowsComponent_0,i3.RenderType_NgxGalleryArrowsComponent)),
      i1.ɵdid(49152,(null as any),0,i4.NgxGalleryArrowsComponent,([] as any[]),{prevDisabled:[0,
          'prevDisabled'],nextDisabled:[1,'nextDisabled'],arrowPrevIcon:[2,'arrowPrevIcon'],
          arrowNextIcon:[3,'arrowNextIcon']},{onPrevClick:'onPrevClick',onNextClick:'onNextClick'})],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:boolean = !_co.canMoveLeft();
        const currVal_1:boolean = !_co.canMoveRight();
        const currVal_2:any = _co.arrowPrevIcon;
        const currVal_3:any = _co.arrowNextIcon;
        _ck(_v,1,0,currVal_0,currVal_1,currVal_2,currVal_3);
      },(null as any));
}
export function View_NgxGalleryThumbnailsComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'div',([] as any[]),
      [[8,'className',0]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          4,'div',[['class','ngx-gallery-thumbnails']],[[4,'left',(null as any)]],
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,
          (null as any),View_NgxGalleryThumbnailsComponent_1)),i1.ɵdid(802816,(null as any),
          0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,
              'ngForOf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵted((null as any),['\n'])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NgxGalleryThumbnailsComponent_2)),
      i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i5.NgxGalleryThumbnailsComponent = _v.component;
    const currVal_2:any = _co.images;
    _ck(_v,5,0,currVal_2);
    const currVal_3:any = _co.canShowArrows();
    _ck(_v,10,0,currVal_3);
  },(_ck,_v) => {
    var _co:i5.NgxGalleryThumbnailsComponent = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(1,'ngx-gallery-thumbnails-wrapper ngx-gallery-thumbnail-size-',
        _co.size,'');
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = _co.thumbnailsLeft;
    _ck(_v,2,0,currVal_1);
  });
}
export function View_NgxGalleryThumbnailsComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ngx-gallery-thumbnails',
      ([] as any[]),(null as any),[[(null as any),'mouseenter'],[(null as any),'mouseleave'],
          ['window','resize']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onMouseEnter()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,1).onMouseLeave()) !== false);
          ad = (pd_1 && ad);
        }
        if (('window:resize' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,1).onResize()) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },View_NgxGalleryThumbnailsComponent_0,RenderType_NgxGalleryThumbnailsComponent)),
      i1.ɵdid(573440,(null as any),0,i5.NgxGalleryThumbnailsComponent,[i6.DomSanitizer,
          i1.ElementRef,i7.NgxGalleryHelperService],(null as any),(null as any))],
      (null as any),(null as any));
}
export const NgxGalleryThumbnailsComponentNgFactory:i1.ComponentFactory<i5.NgxGalleryThumbnailsComponent> = i1.ɵccf('ngx-gallery-thumbnails',
    i5.NgxGalleryThumbnailsComponent,View_NgxGalleryThumbnailsComponent_Host_0,{images:'images',
        columns:'columns',rows:'rows',arrows:'arrows',arrowsAutoHide:'arrowsAutoHide',
        margin:'margin',selectedIndex:'selectedIndex',clickable:'clickable',swipe:'swipe',
        size:'size',arrowPrevIcon:'arrowPrevIcon',arrowNextIcon:'arrowNextIcon'},{onActiveChange:'onActiveChange'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/venyou-stripe/src/$$_gendir/~/ngx-gallery/lib/ngx-gallery-thumbnails.component.ngfactory.ts